exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cancel-calendar-event[data-v-266b9bae] {\n  margin-right: 10px;\n  width: calc(50% - 5px);\n}\n.save-calendar-event[data-v-266b9bae] {\n  width: calc(50% - 5px);\n}\n.full-width[data-v-266b9bae] {\n  width: 100%;\n}\n.width-third[data-v-266b9bae] {\n  width: calc(100% / 3);\n}\n.skeleton[data-v-266b9bae] {\n  border-color: rgb(217, 217, 217);\n  border-radius: 4px;\n  height: 32px;\n  width: 100%;\n}\n.validation-error[data-v-266b9bae] {\n  font-style: italic;\n  color: red;\n  text-align: right;\n}\n", ""]);

// exports
